<template>
  <Modal :show="visible" @close="closeDialog">
    <template #header>
      <h3 class="text-lg font-medium">编辑问题</h3>
    </template>

    <template #body>
      <div class="mt-4">
        <label
          for="questionText"
          class="block text-sm font-medium text-gray-700 dark:text-gray-300"
        >
          问题内容
        </label>
        <textarea
          id="questionText"
          v-model="questionText"
          rows="3"
          class="mt-1 p-2 block w-full rounded-md shadow-sm border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 dark:text-gray-200 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          placeholder="请输入问题内容"
        />
      </div>
    </template>

    <template #footer>
      <div class="flex justify-end space-x-3">
        <button
          @click="closeDialog"
          class="cancel-btn sm:text-sm"
        >
          取消
        </button>
        <LoadingBtn
          :is-loading="isLoading"
          text="保存"
          loading-text="保存中..."
          @click="handleSubmit"
          class="inline-flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
        />
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import Modal from "@/components/ui/Modal.vue";
import LoadingBtn from "@/components/ui/LoadingBtn.vue";
import { updateQuestionAPI } from "@/api/speaking/topic";
import toast from "@/utils/toaster";
import type { Question } from "@/types/topic/topic";

const props = defineProps<{
  visible: boolean;
  question: Question | null;
}>();

const emit = defineEmits<{
  (e: "update:visible", value: boolean): void;
  (e: "question-updated"): void;
}>();

const questionText = ref("");
const isLoading = ref(false);

watch(
  () => props.question,
  (newQuestion) => {
    if (newQuestion) {
      questionText.value = newQuestion.question;
    }
  },
  { immediate: true }
);

const closeDialog = () => {
  emit("update:visible", false);
  questionText.value = "";
};

const handleSubmit = async () => {
  if (!props.question) return;
  if (!questionText.value.trim()) {
    toast.error("请输入问题内容");
    return;
  }

  try {
    isLoading.value = true;
    await updateQuestionAPI(props.question.questionId, questionText.value.trim());
    toast.success("问题更新成功");
    emit("question-updated");
    closeDialog();
  } catch (error: any) {
    toast.error(error.message || "更新失败");
  } finally {
    isLoading.value = false;
  }
};
</script> 